import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path d="M1 1L21.9099 21.7L42.7799 1" stroke={fill} strokeMiterlimit="10" strokeLinecap="round" />
      <path
        d="M21.89 30.2001C23.707 30.2001 25.1801 28.7271 25.1801 26.9101C25.1801 25.0931 23.707 23.6201 21.89 23.6201C20.073 23.6201 18.6001 25.0931 18.6001 26.9101C18.6001 28.7271 20.073 30.2001 21.89 30.2001Z"
        fill={fill}
      />
      <path d="M21.8896 21.7V24.67" stroke={fill} strokeMiterlimit="10" strokeLinecap="round" />
    </g>
  )
}
